// Errors Getters

export const getErrorsList = state => {
  return state.errorsList
}

export const getResetValidationErrors = state => {
  return state.resetValidationErrors
}
